import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export interface ClientDashboardFilters {
  startDate?: string
  endDate?: string
  languages?: string[]
  requesters?: string[]
  subAccounts?: number[]
}

export interface ClientFilterOption {
  key: string
  value: string
  parentKeys?: string[]
}

export interface ClientFilterOptions {
  subAccounts: ClientFilterOption[]
  requesters: ClientFilterOption[]
}

export interface ClientDashboardOverview {
  openAppointments: number
  confirmedAppointments: number
  interpretationServedMinutes: number
  completionRate: number

  opiMetrics: OPIMetrics
  scheduledServicesMetrics: ScheduledServicesMetrics

  volumeTrend: MonthlyVolume[]
  languageDistribution: LanguageDistribution[]

  opiStatusBuckets: StatusBucket[]
  scheduledStatusBuckets: StatusBucket[]

  upcomingAppointments: UpcomingAppointment[]
}

export interface OPIMetrics {
  totalCalls: number
  totalMinutes: number
  fulfillmentRate: number
  avgConnectionTimeSeconds: number
  avgDuration: string
}

export interface ScheduledServicesMetrics {
  totalAppointments: number
  totalMinutes: number
  fulfillmentRate: number
  cancellationRate: number
  avgDuration: string
}

export interface MonthlyVolume {
  label: string
  minutes: number
}

export interface LanguageDistribution {
  language: string
  minutes: number
  percentage: number
}

export interface StatusBucket {
  label: string
  completed: number
  cancelledOrAbandoned: number
}

export interface UpcomingAppointment {
  appointmentId: number
  startTime: string
  endTime: string
  clientName: string
  language: string
  location: string
  serviceType: string
}

export async function getClientDashboardOverview(
  filters: ClientDashboardFilters
): Promise<ClientDashboardOverview> {
  const response = await axios.post(`${API_URL}/Dashboard/client-overview`, filters)
  return response.data.data
}

export async function getClientFilterOptions(): Promise<ClientFilterOptions> {
  const response = await axios.get(`${API_URL}/Dashboard/client-filter-options`)
  return response.data.data ?? {subAccounts: [], requesters: []}
}
